module.exports = require("string-hash");